"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityOp = void 0;
var rxjs_1 = require("rxjs");
var IdentitySourceRequestImpulse_1 = require("../graphql/request/input/IdentitySourceRequestImpulse");
var DataRef_1 = require("./DataRef");
var IdentityImportImpulse_1 = require("../graphql/request/input/IdentityImportImpulse");
var GaiaScalars_1 = require("../graphql/GaiaScalars");
var operators_1 = require("rxjs/operators");
var IdentityOp = /** @class */ (function () {
    function IdentityOp(client) {
        this.client = client;
    }
    IdentityOp.prototype.import = function (tenantId, identityName, content, override, identityId) {
        var _this = this;
        if (override === void 0) { override = false; }
        var fileName = identityName + "-" + Date.now();
        return new DataRef_1.DataRef("gaia://" + tenantId + "/identities/", this.client)
            .add(fileName, content, override)
            .pipe(operators_1.mergeMap(function (dataRef) {
            return rxjs_1.defer(function () { return _this.importIdentity(dataRef.getUri(), tenantId, identityName, override, identityId)
                .catch(function (reason) { throw new Error('Identity Upload failed: ' + reason); }); });
        }));
    };
    IdentityOp.prototype.importIdentity = function (uri, tenantId, identityName, override, identityId) {
        if (override === void 0) { override = false; }
        return this.client.post(new IdentityImportImpulse_1.IdentityImportImpulse(uri, tenantId, identityId || GaiaScalars_1.UUID.randomUUID().toString(), identityName, override), '/identity/import')
            .then(function (response) {
            return {
                partitionKey: response.partitionKey,
                uri: response.uri
            };
        }, function (reason) {
            throw new Error('Identity Import failed: ' + reason);
        });
    };
    IdentityOp.prototype.export = function (identityId) {
        var _this = this;
        return rxjs_1.defer(function () { return _this.client.postAndRetrieveBinary(new IdentitySourceRequestImpulse_1.IdentitySourceRequestImpulse(identityId), '/identity/source')
            .catch(function (reason) {
            throw new Error('Exporting identity with id ' + identityId + ' failed: ' + reason);
        }); });
    };
    return IdentityOp;
}());
exports.IdentityOp = IdentityOp;
//# sourceMappingURL=IdentityOp.js.map